import axios from 'axios';

export const fetchAppointments = (data) => {
  let arrStr = encodeURIComponent(JSON.stringify(data.dow));
  let patientPrefs = encodeURIComponent(JSON.stringify(data.patientPrefs));
  return axios.get(
    `${process.env.REACT_APP_FLEXAPP}/os/getschedule?c=${data.client}&appointmentId=${data.appointmentId}&providerId=${data.providerId}&dow=${arrStr}&patientPrefs=${patientPrefs}&month=${data.month}&year=${data.year}`,
  );
};

export const fetchAllAppointments = (data) => {
  let arrStr = encodeURIComponent(JSON.stringify(data.dow));
  let patientPrefs = encodeURIComponent(JSON.stringify(data.patientPrefs));
  return axios.get(
    `${process.env.REACT_APP_FLEXAPP}/os/getAllSchedule?c=${data.client}&appointmentId=${data.appointmentId}&providerId=${data.providerId}&dow=${arrStr}&patientPrefs=${patientPrefs}&month=${data.month}&year=${data.year}`,
  );
};

export const createAppointment = (data) => {
  let guarantor = null;
  if (data.guarantor) {
    guarantor = {
      ...data.guarantor,
      phone: `1${data.guarantor.phone.replace(/[^\d]/g, '')}`,
    };
  }

  const patientInfo = {
    email: data.email,
    fname: data.fname,
    lname: data.lname,
    phone: `1${data.phone}`,
    dob: data.dob,
    insurance: data.insurance,
    insurance_change: data.insuranceChange,
    language: data.language,
    returning: data.returning,
    subscriber_id: data.subscriber_id,
    tracking: data.tracking,
    qas: data.qas,
    token: data.token,
    expiry: data.expiry,
    lastfour: data.lastfour,
    confirmationTokenId: data.confirmationTokenId,
    paymentIntentId: data.paymentIntentId,
    setupIntentId: data.setupIntentId,
    returnUrl: data.returnUrl,
    merchant: data.merchant,
    appointmentName: data.appointmentName,
    guarantor,
  };

  if (data.resumingFromSavedState) {
    patientInfo.resumingFromSavedState = true;
  }

  if (data.confirmationTokenId) {
    patientInfo.confirmationTokenId = data.confirmationTokenId;
  }

  if (data.merchant) {
    patientInfo.merchant = data.merchant;
  }

  if (data.paymentIntentId) {
    patientInfo.paymentIntentId = data.paymentIntentId;
  }

  if (data.setupIntentId) {
    patientInfo.setupIntentId = data.setupIntentId;
  }

  let url = `${process.env.REACT_APP_FLEXAPP}/os/createAppointment?c=${data.client}&appointment_date=${data.appointment_date}&appointment_id=${data.appointment_id}&appointment_time=${data.appointment_time}&operatory=${data.operatory}&provider_id=${data.provider_id}`;

  if (data.liineSessionId) {
    url = `${url}&liine_session_id=${data.liineSessionId}`;
  }

  const rwgTokenCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_rwg_token='));

  if (typeof rwgTokenCookie !== 'undefined') {
    const rwgTokenVal = rwgTokenCookie.split('=')[1];
    url += `&google_reserve_token=${encodeURIComponent(rwgTokenVal)}`;
  }

  const config = data.idempotencyKey
    ? { headers: { 'Idempotency-Key': data.idempotencyKey } }
    : undefined;

  return axios.post(url, patientInfo, config);
};

export const surchargeQuote = (data) => {
  let guarantor = null;
  if (data.guarantor) {
    guarantor = {
      ...data.guarantor,
      phone: `1${data.guarantor.phone.replace(/[^\d]/g, '')}`,
    };
  }

  const body = {
    email: data.email,
    fname: data.fname,
    lname: data.lname,
    phone: `1${data.phone}`,
    dob: data.dob,
    paymentMethodId: data.paymentMethodId,
    paymentIntentId: data.paymentIntentId,
    yeeldTransactionId: data.yeeldTransactionId,
    guarantor,
  };

  const url = `${process.env.REACT_APP_FLEXAPP}/os/surchargeQuote?c=${data.client}&appointment_date=${data.appointment_date}&appointment_id=${data.appointment_id}&appointment_time=${data.appointment_time}&operatory=${data.operatory}&provider_id=${data.provider_id}`;

  const config = data.idempotencyKey
    ? { headers: { 'Idempotency-Key': data.idempotencyKey } }
    : undefined;

  return axios.post(url, body, config);
};

export const verifyAppointment = (data) => {
  return axios.get(
    `${process.env.REACT_APP_FLEXAPP}/os/sendVerification?phone=${data.phone}`,
  );
};

export const checkVerification = (data) => {
  return axios.get(
    `${process.env.REACT_APP_FLEXAPP}/os/checkVerification?phone=${data.phone}`,
  );
};
